import script from "./StarRating.vue?vue&type=script&setup=true&lang=js"
export * from "./StarRating.vue?vue&type=script&setup=true&lang=js"

import "./StarRating.vue?vue&type=style&index=0&id=74a11aae&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74a11aae"]])

export default __exports__